import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-info-snackbar',
    templateUrl: './info-snackbar.component.html',
    styleUrls: ['./info-snackbar.component.scss'],
    standalone: false
})
export class InfoSnackbarComponent {
  constructor(
    public snackBar: MatSnackBar,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  onClick(event) {
    // do something
  }
  onClickDismiss(event) {
    // do something and dismiss
    this.snackBar.dismiss();
  }
}
